import './Statistics.css';
import { useSelector, useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import Container from 'react-bootstrap/Container';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import {Printer, QuestionCircle} from 'react-bootstrap-icons';
import Row from 'react-bootstrap/Row';

let firstAge = 0;

function Statistics() {
  const [statisticsModal, setStatisticsModal] = useState(false);
  const handleStatisticsModal = () => {
    setStatisticsModal(!statisticsModal);
  }

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: 'FETCH_STATISTICS' });

  }, []);

  let firstAgeRange = 0;
  let secondAgeRange = 0;
  let thirdAgeRange = 0
  let fourthAgeRange = 0;
  let fifthAgeRange = 0;
  let femaleGender = 0;
  let maleGender = 0;
  let otherGender = 0;
  let pntsGender = 0;
  let americanIndianRace = 0;
  let africanAmericanRace = 0
  let asianRace = 0;
  let nativeHawaiianRace = 0;
  let latinRace = 0;
  let whiteRace = 0;
  let otherRace = 0;
  let pntsRace = 0;
  let veteranYes = 0;
  let veteranNo = 0;
  let veteranPnts = 0;
  let salaryFirstRange = 0;
  let salarySecondRange = 0;
  let salaryThirdRange = 0;
  let salaryFourthRange = 0;
  let salaryFifthRange = 0;
  let firstReason = 0;
  let secondReason = 0;
  let thirdReason = 0;
  let fourthReason = 0;
  let educationFirst = 0;
  let educationSecond = 0;
  let educationThird = 0;
  let educationFourth = 0;
  let educationFifth = 0;
  let educationSixth = 0;
  let educationSeventh = 0;


  //const clients = useSelector((store) => store.requestReducer.closed);
  const clients = useSelector((store) => store.statisticsReducer);
  console.log("close", clients);
  function clientsAgeTable() {
    console.log("close", clients);


    for (let i = 0; i < clients.length; i++) {
      if (clients[i].dob < 25 && clients[i].dob > 17) {
        firstAgeRange = firstAgeRange = 1;
      }

      else if (clients[i].dob < 45 && clients[i].dob > 26) {
        secondAgeRange = secondAgeRange + 1;
      }
      else if (clients[i].dob < 55 && clients[i].dob > 46) {
        thirdAgeRange = thirdAgeRange + 1;
      }
      else if (clients[i].dob < 65 && clients[i].dob > 56) {
        fourthAgeRange = fourthAgeRange + 1;
      }
      else if (clients[i].dob > 66) {
        fifthAgeRange = fifthAgeRange + 1;
      }
    }
  }

  function clientsGenderTable() {

    for (let i = 0; i < clients.length; i++) {

      if (clients[i].gender == 0) {
        femaleGender = femaleGender + 1;
      }
      else if (clients[i].gender == 1) {
        maleGender = maleGender + 1;
      }
      else if (clients[i].gender == 2) {
        otherGender = otherGender + 1;
      }
      else if (clients[i].gender == 3) {
        pntsGender = pntsGender + 1;
      }
    }
  }


  function clientsRaceTable() {
    for (let i = 0; i < clients.length; i++) {

      if (clients[i].race == 0) {
        americanIndianRace = americanIndianRace + 1;
      }
      else if (clients[i].race == 1) {
        africanAmericanRace = africanAmericanRace + 1;
      }
      else if (clients[i].race == 2) {
        asianRace = asianRace + 1;
      }
      else if (clients[i].race == 3) {
        nativeHawaiianRace = nativeHawaiianRace + 1;
      }
      else if (clients[i].race == 4) {
        latinRace = latinRace + 1;
      }
      else if (clients[i].race == 5) {
        whiteRace = whiteRace + 1;
      }
      else if (clients[i].race == 6) {
        otherRace = otherRace + 1;
      }
      else if (clients[i].race == 7) {
        pntsRace = pntsRace + 1;
      }
    }
  }

  function clientsVeteranTable() {

    for (let i = 0; i < clients.length; i++) {

      if (clients[i].veteran == 0) {
        veteranYes = veteranYes + 1;
      }
      else if (clients[i].veteran == 1) {
        veteranNo = veteranNo + 1;
      }
      else if (clients[i].veteran == 2) {
        veteranPnts = veteranPnts + 1;
      }

    }
  }


  function clientsSalaryTable() {

    for (let i = 0; i < clients.length; i++) {

      if (clients[i].monthly_income > 2999 && clients[i].monthly_income < 4000) {
        salaryFirstRange = salaryFirstRange + 1;
      }
      else if (clients[i].monthly_income > 1999 && clients[i].monthly_income < 3000) {
        salarySecondRange = salarySecondRange + 1;
      }
      else if (clients[i].monthly_income > 999 && clients[i].monthly_income < 2000) {
        salaryThirdRange = salaryThirdRange + 1;
      }
      else if (clients[i].monthly_income > 0 && clients[i].monthly_income < 1000) {
        salaryFourthRange = salaryFourthRange + 1;
      }
      else if (clients[i].monthly_income == 0) {
        salaryFifthRange = salaryFifthRange + 1;
      }
    }
  }

  function clientsEducationTable() {
    for (let i = 0; i < clients.length; i++) {

      if (clients[i].education == 0) {
        educationFirst = educationFirst + 1;
      }
      else if (clients[i].education == 1) {
        educationSecond = educationSecond + 1;
      }
      else if (clients[i].education == 2) {
        educationThird = educationThird + 1;
      }
      else if (clients[i].education == 3) {
        educationFourth = educationFourth + 1;
      }
      else if (clients[i].education == 4) {
        educationFifth = educationFifth + 1;
      }
      else if (clients[i].education == 5) {
        educationSixth = educationSixth + 1;
      }
      else if (clients[i].education == 6) {
        educationSeventh = educationSeventh + 1;
      }
    }
  }

  function clientsReasonTable() {

    for (let i = 0; i < clients.length; i++) {
      if (clients[i].reason == 0) {
        firstReason = firstReason + 1;
      }
      else if (clients[i].reason == 1) {
        secondReason = secondReason + 1;
      }
      else if (clients[i].reason == 2) {
        thirdReason = thirdReason + 1;
      }
      else if (clients[i].reason == 3) {
        fourthReason = fourthReason + 1;
      }
    }
  }

  clientsEducationTable();
  clientsReasonTable();
  clientsSalaryTable();
  clientsVeteranTable();
  clientsRaceTable();
  clientsGenderTable();
  clientsAgeTable();
  function printDiv() {
    var printContents = document.getElementById("printableArea").innerHTML;
    var originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;

    window.print();

    document.body.innerHTML = originalContents;
  }
  return (
    <>
      <Modal
        size="md"
        show={statisticsModal}
        onHide={() => handleStatisticsModal()}
        animation={false}
      >
        <Modal.Header>
          <Modal.Title className="w-100 text-center">
            INSTRUCTIONS
                    </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
        <p>These are demographic statistics for all of the clients that have successfully picked up furniture from the warehouse</p>
        <p>Clients that have submitted requests but have not picked up furniture for whatever reason are not included in the statistics below.</p>
        <p>To print, press the <Printer color="#3898ac" size={30} /> icon.</p>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="primary"
            onClick={handleStatisticsModal}
          >CLOSE</Button>
        </Modal.Footer>
      </Modal>

      <Container fluid>
      <Row className="ml-3 mb-3 d-flex justify-content-left align-middle"><h3 id="statisticsHeader">CLIENTS</h3><QuestionCircle
          className="ml-3 mt-0"
          type="button"
          color="#d1a228" size={30}
          onClick={handleStatisticsModal} />
          <Printer
          type="button"
          className="ml-3 mt-0" 
          color="#3898ac" size={30}
          onClick={() => printDiv()}
          />
          </Row>

        <div id="printableArea" >
          <h1>Total Number of Clients: {clients.length}</h1>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>By Age</th>
                <th>18-24</th>
                <th>25-44</th>
                <th>45-54</th>
                <th>55-64</th>
                <th>65+</th>

              </tr>
            </thead>
            <tbody>
              <tr>
                <td>% of Total</td>
                <td>{Math.round((firstAgeRange / clients.length) * 100)}%</td>
                <td>{Math.round((secondAgeRange / clients.length) * 100)}%</td>
                <td>{Math.round((thirdAgeRange / clients.length) * 100)}%</td>
                <td>{Math.round((fourthAgeRange / clients.length) * 100)}%</td>
                <td>{Math.round((fifthAgeRange / clients.length) * 100)}%</td>
              </tr>
              <tr>
                <td>Total: {clients.length}</td>
                <td> {firstAgeRange}</td>
                 <td> {secondAgeRange}</td>
                 <td>{thirdAgeRange}</td>
                 <td> {fourthAgeRange}</td>
                <td> {fifthAgeRange}</td>
              </tr>
            </tbody>
          </Table>

          <br></br>
          <br></br>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>By Gender</th>
                <th>Female</th>
                <th>Male</th>
                <th>Other </th>
                <th>Prefer Not To Respond</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>% of Total</td>
                <td>{Math.round((femaleGender / clients.length) * 100)}%</td>
                <td>{Math.round((maleGender / clients.length) * 100)}%</td>
                <td>{Math.round((otherGender / clients.length) * 100)}%</td>
                <td>{Math.round((pntsGender / clients.length) * 100)}%</td>
              </tr>
              <tr>
                <td>Total: {clients.length}</td>
                <td> {femaleGender}</td>
                 <td> {maleGender}</td>
                 <td>{otherGender}</td>
                 <td> {pntsGender}</td>
              </tr>
            </tbody>
          </Table>
          <br></br>
          <br></br>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>By Race</th>
                <th>African American or Black</th>
                <th>American Indian</th>
                <th>Asian </th>
                <th>Native Hawaiian or Pacific Islander</th>
                <th>Latin/Latinx</th>
                <th>White </th>
                <th>Other</th>
                <th>Prefer Not To Respond</th>


              </tr>

            </thead>
            <tbody>
              <tr>
                <td>% of Total</td>
                <td>{Math.round((africanAmericanRace / clients.length) * 100)}%</td>
                <td>{Math.round((americanIndianRace / clients.length) * 100)}%</td>
                <td>{Math.round((asianRace / clients.length) * 100)}%</td>
                <td>{Math.round((nativeHawaiianRace / clients.length) * 100)}%</td>
                <td>{Math.round((latinRace / clients.length) * 100)}%</td>
                <td>{Math.round((whiteRace / clients.length) * 100)}%</td>
                <td>{Math.round((otherRace / clients.length) * 100)}%</td>
                <td>{Math.round((pntsRace / clients.length) * 100)}%</td>

              </tr>
              <tr>
                <td>Total: {clients.length}</td>
                <td> {africanAmericanRace}</td>
                 <td> {americanIndianRace}</td>
                 <td>{asianRace}</td>
              <td> {nativeHawaiianRace}</td>
                 <td> {latinRace}</td>
                 <td>{whiteRace}</td>
                 <td> {otherRace}</td>
                 <td>{pntsRace}</td>
              </tr>

            </tbody>
          </Table>
          <br></br>
          <br></br>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>By Veteran Status</th>
                <th>Yes</th>
                <th>No</th>
                <th>Prefer Not To Respond</th>


              </tr>
            </thead>
            <tbody>
              <tr>
                <td>% of Total</td>
                <td>{Math.round((veteranYes / clients.length) * 100)}%</td>
                <td>{Math.round((veteranNo / clients.length) * 100)}%</td>
                <td>{Math.round((veteranPnts / clients.length) * 100)}%</td>
              </tr>
              <tr>
                <td>Total: {clients.length}</td>
                <td> {veteranYes}</td>
                 <td> {veteranNo}</td>
                 <td>{veteranPnts}</td>
              </tr>
        
            </tbody>
          </Table>
          <br></br>
          <br></br>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>By Education Level</th>
                <th>Less than High School</th>
                <th>High School diploma/GED</th>
                <th>Technical Certification</th>
                <th>Some College</th>
                <th>College Degree</th>
                <th>Graduate Degree</th>
                <th>Prefer Not To Respond</th>


              </tr>
            </thead>
            <tbody>
              <tr>
                <td>% of Total</td>
                <td>{Math.round((educationFirst / clients.length) * 100)}%</td>
                <td>{Math.round((educationSecond / clients.length) * 100)}%</td>
                <td>{Math.round((educationThird / clients.length) * 100)}%</td>
                <td>{Math.round((educationFourth / clients.length) * 100)}%</td>
                <td>{Math.round((educationFifth / clients.length) * 100)}%</td>
                <td>{Math.round((educationSixth / clients.length) * 100)}%</td>
                <td>{Math.round((educationSeventh / clients.length) * 100)}%</td>

              </tr>
              <tr>
                <td>Total: {clients.length}</td>
                <td> {educationFirst}</td>
                 <td> {educationSecond}</td>
                 <td> {educationThird}</td>
                 <td> {educationFourth}</td>
                 <td>{educationFifth}</td>
                 <td> {educationSixth}</td>
                 <td> {educationSeventh}</td>
                
              </tr>
            </tbody>
          </Table>
          <br></br>
          <br></br>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>By Income Level(gross monthly)</th>
                <th>3,000-3,900</th>
                <th>2,000-2,900</th>
                <th>1,000-1,900</th>
                <th>1-999</th>
                <th>0</th>



              </tr>
    
            </thead>
            <tbody>
              <tr>
                <td>% of Total</td>
                <td>{Math.round((salaryFirstRange / clients.length) * 100)}%</td>
                <td>{Math.round((salarySecondRange / clients.length) * 100)}%</td>
                <td>{Math.round((salaryThirdRange / clients.length) * 100)}%</td>
                <td>{Math.round((salaryFourthRange / clients.length) * 100)}%</td>
                <td>{Math.round((salaryFifthRange / clients.length) * 100)}%</td>

              </tr>
              <tr>
                <td>Total: {clients.length}</td>
                <td> {salaryFirstRange}</td>
                 <td> {salarySecondRange}</td>
                 <td> {salaryThirdRange}</td>
                 <td> {salaryFourthRange}</td>
                 <td>{salaryFifthRange}</td>
              </tr>
            </tbody>
          </Table>
          <br></br>
          <br></br>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>By Event</th>
                <th>Fire</th>
                <th>Flood</th>
                <th>Restarting Life</th>
                <th>Other</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>% of Total</td>
                <td>{Math.round((firstReason / clients.length) * 100)}%</td>
                <td>{Math.round((secondReason / clients.length) * 100)}%</td>
                <td>{Math.round((thirdReason / clients.length) * 100)}%</td>
                <td>{Math.round((fourthReason / clients.length) * 100)}%</td>
                
              </tr>
              <tr>
                <td>Total: {clients.length}</td>
                <td> {firstReason}</td>
                 <td> {secondReason}</td>
                 <td> {thirdReason}</td>
                 <td> {fourthReason}</td>
              </tr>
            </tbody>
          </Table>
          <br></br>
          <br></br>
        </div>
      </Container>
    </>
  )
}

export default Statistics;